import { render, staticRenderFns } from "./placePartEdit.vue?vue&type=template&id=48bff6a3&scoped=true&"
import script from "./placePartEdit.vue?vue&type=script&lang=js&"
export * from "./placePartEdit.vue?vue&type=script&lang=js&"
import style0 from "./placePartEdit.vue?vue&type=style&index=0&id=48bff6a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bff6a3",
  null
  
)

export default component.exports